import type { Video } from '../types/video.js';

export function normalizeSearchText(text: string): string {
    return text
        .toLowerCase()
        .replace(/[ıİ]/g, 'i')
        .replace(/[şŞ]/g, 's')
        .replace(/[ğĞ]/g, 'g')
        .replace(/[üÜ]/g, 'u')
        .replace(/[öÖ]/g, 'o')
        .replace(/[çÇ]/g, 'c')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
}

export function videoMatchesSearchQuery(video: Video, query: string): boolean {
    const normalizedQuery = normalizeSearchText(query);
    if (!normalizedQuery) return false;

    const haystack = normalizeSearchText([
        video.snippet.title,
        video.snippet.description,
        video.snippet.channelTitle
    ].join(' '));

    if (haystack.includes(normalizedQuery)) return true;

    const tokens = normalizedQuery.split(' ').filter(token => token.length > 1);
    return tokens.length > 0 && tokens.every(token => haystack.includes(token));
}
